import React from 'react';
import { Box, Avatar, Typography } from '@mui/material';
import './style.css';
import NavListItem from './NavListItem';

interface DisplayNameBadgeProps {
    displayName: string;
}

const DisplayNameBadge: React.FC<DisplayNameBadgeProps> = ({ displayName }) => {
    const getInitials = (name: string) => {
        const parts = name.trim().split(' ');
        if (parts.length === 1) return parts[0].charAt(0).toUpperCase();
        return (parts[0].charAt(0) + parts[parts.length - 1].charAt(0)).toUpperCase();
    };

    return (
        <NavListItem label={displayName} iconElement={
            <Avatar className="display-name-avatar">
                {getInitials(displayName)}
            </Avatar>
        } />
    );
};

export default DisplayNameBadge;